import { Deliverable } from '@app/features/scoping/models/deliverable.model'
import { DeliverableChanges } from '@app/shared/components/scope-elements/models/entities-with-changes/deliverable-with-changes.interface'

export function getDeliverableChanges(deliverable: Deliverable, previewDeliverable: Deliverable): DeliverableChanges {
  if (!previewDeliverable) previewDeliverable = deliverable

  return {
    agencyPrice: {
      old: deliverable?.getTotalSellingPrice()?.amount,
      new: previewDeliverable?.getTotalSellingPrice()?.amount,
    },
    quantity: {
      old: deliverable?.quantity,
      new: previewDeliverable?.quantity,
    },
    rateCardTotalHours: {
      old: deliverable?.getTotalRateCardHours(),
      new: previewDeliverable?.getTotalRateCardHours(),
    },
    budgetBalance: {
      old: deliverable?.budgetBalance?.amount,
      new: previewDeliverable?.budgetBalance?.amount,
    },
    totalProfit: {
      old: deliverable?.getTotalProfit()?.amount,
      new: previewDeliverable?.getTotalProfit()?.amount,
    },
    markup: {
      old: deliverable?.getMarkup(),
      new: previewDeliverable?.getMarkup(),
    },
  }
}
